import React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import "./Program.scss";
import verifiedBadge from "../../../images/verified.png";
import { useTranslation } from "react-i18next";

const ProgramTree = (props) => {
  const { t, i18n } = useTranslation(false, { useSuspense: false });

  return (
    <div className="col-sm-6">
      <div className="mb-4">
        <div
          className="card card-program card-item"
          style={{ background: "none" }}
        >
          {
            props.params_url ? (
              <Link
              to={`/program/tree?id=${props.id}&${props.params_url}`}
              className="link-absolute"
            ></Link>
            ) : (
              <Link
              to={`/program/tree?id=${props.id}`}
              className="link-absolute"
            ></Link>
            )
          }
          
          <div className="card-program-image">
            <img
              src={props.urlFeaturedImage}
              className="card-image"
              alt={props.title}
            />
          </div>
          <div className="card-body-blank">
            <h3 className="card-program-title mt-0 mb-1">{props.title}</h3>
            <div className="card-program-seller card-text-small mb-1">
              <i className="fa fa-user"></i> {props.corporateName}
            </div>
            <div className="card-program-location card-text-small mb-1">
              <i className="fa fa-map-marker-alt"></i> {props.province}
            </div>
            <span className="card-price text-orange">
              {props.minPrice === props.maxPrice ? (
                <span>
                  Rp{" "}
                  <NumberFormat
                    value={props.priceRange}
                    displayType={"text"}
                    decimalScale={0}
                    thousandSeparator={","}
                    decimalSeparator={"."}
                  />
                </span>
              ) : (
                <span>
                  Rp{" "}
                  <NumberFormat
                    value={props.minPrice}
                    displayType={"text"}
                    decimalScale={0}
                    thousandSeparator={","}
                    decimalSeparator={"."}
                  />{" "}
                  -{" "}
                  <NumberFormat
                    value={props.maxPrice}
                    displayType={"text"}
                    decimalScale={0}
                    thousandSeparator={","}
                    decimalSeparator={"."}
                  />
                </span>
              )}
              <br/>
              <small>per {t("ProgramTree.pohon")}</small>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProgramTree;
